export const en = {
    api_app: 'API app',
    commander: 'Direct Commander',
    direct_mobile_app: 'Direct mobile app',
    other: 'Automatic change',
    web: 'Web interface',
    xls: 'XLS/XLSX'
};
